import React from "react";

import { Typography } from "@packages/ds";
import { FormattedMessage, useIntl } from "react-intl";

import { Link } from "ds/Button";

export const NoDeletePermission = () => {
  const intl = useIntl();
  return (
    <>
      <Typography.BodyText size="small">
        <FormattedMessage
          id="no_delete_permission"
          values={{
            link: txt => (
              <Link
                analyticId="delete_branch_link"
                href={intl.formatMessage({
                  id: "delete_branch_link"
                })}
              >
                {txt}
              </Link>
            )
          }}
        />
      </Typography.BodyText>
    </>
  );
};
